import { Injectable } from '@angular/core';
import { CommonService } from '../../commons/services/common.service';

@Injectable()
export class GestionDAC {
    public static printDACMouv(clefMouvCourantArg, common: CommonService)  {
      const param = {
        'servlet': 'DBImprimeDAC',
        'module': 'Recylog',
        'type': 'map',
        'compression': 'true',
        'pathImpression': 'Recylog/tmp/dac/',
        'data': {
          'LISTE_MOUVEMENT': clefMouvCourantArg,
          'CLEF_SITE': {
            'typeParam': 'int',
            'valeur': common.user[2]
          },
          'CLEF_USER': {
            'typeParam': 'int',
            'valeur': common.user[0]
          },
  
        }
      };
  

        return common.post('', { param: param });
    }

}
